import { Typography } from '@mui/material';

import { ReturnComponent, Style } from '../../utils/reactTypes';
import { Outline } from '../layout/Outline';
import { NONE_TEXT } from './AxleInfoField';

export const DangerousHtmlTypography = ({
    children,
    style = {},
}: {
    children: string;
    style?: Style;
}): ReturnComponent => {
    if (children === '') return <>{NONE_TEXT}</>;
    return (
        <Outline>
            <Typography dangerouslySetInnerHTML={{ __html: children }} style={style} />
        </Outline>
    );
};
